<template>
  <my-modal>
    <div class="modal-container">
      <div class="modal-header">
        <h3>Seleccionar cliente</h3>
      </div>
      <div class="modal-body">
        <DataList url="/clientes" :fields="fields" :rowClick="selectCliente" :modal="true"></DataList>
      </div>
      <div class="modal-footer">
        <button class="btn btn-danger" @click="cerrarModal">Cerrar</button>
      </div>
    </div>
  </my-modal>
</template>
<script>
import DataList from "@/components/layouts/DataList";
import MyModal from "@/components/layouts/MyModal";
export default {
  name: "ModalSelectCliente",
  components: {
    DataList,
    MyModal
  },
  data() {
    return {
      fields: [
        {
          name: "nombre",
          label: "Nombre",
          type: "title",
          class: ""
        },
        {
          name: "numero_documento",
          label: "N° documento",
          type: "field",
          class: ""
        },
        {
          name: "domicilio",
          label: "Domicilio",
          type: "field",
          class: ""
        },
        {
          name: "localidad",
          label: "Localidad",
          type: "field",
          class: ""
        },
        {
          name: "codigo_postal",
          label: "CP",
          type: "field",
          class: ""
        },
        {
          name: "telefono",
          label: "Teléfono",
          type: "field",
          class: ""
        },
        {
          name: "responsabilidad_iva.descripcion",
          label: "IVA",
          type: "field",
          class: ""
        }
      ],
      loading: false
    };
  },
  created(){
    const unregisterRouterGuard = this.$router.beforeEach((to, from, next) => {
      this.cerrarModal()
      next(false)
    })

    this.$once('hook:destroyed', () => {
      unregisterRouterGuard()
    })
  },
  methods: {
    selectCliente(cliente) {
      this.$emit("selectCliente", cliente);
      this.cerrarModal()
    },
    cerrarModal() {
      this.$emit("cerrarModalCliente");
    }
  }
};
</script>
